<template>
    <div class="modal fade" id="modalEnterprise" aria-labelledby="modalEnterpriseLabel" tabindex="-1" :data-bs-backdrop="hasEnterprise ? 'true' : 'static'" :data-bs-keyboard="hasEnterprise ? 'true' : 'false'">
        <div class="modal-dialog mt-5">
            <div class="modal-content border-0 shadow-lg" style="border-radius: 20px;">
                <div class="modal-header border-0 pb-0 pt-4 px-4">
                    <h5 class="modal-title fw-bold" id="modalEnterpriseLabel" style="color: #1e293b; font-size: 18px; letter-spacing: -0.5px;">{{modalTitle}}</h5>
                    <i v-if="hasEnterprise" data-bs-dismiss="modal" aria-label="Close" class="siscont icon_x text-muted" id="btnCloseModalEnterprise" @click="removeFocus" style="cursor:pointer; font-size: 20px; transition: color 0.2s;" onmouseover="this.style.color='#ef4444'" onmouseout="this.style.color='#94a3b8'"/>
                </div>
                <div class="modal-body px-4 pt-2">
                   <p class="text-muted mb-4" style="font-size: 14px;">Selecione a empresa que você deseja gerenciar neste momento.</p>
                   
                   <div class="enterprise-cards-container">
                      <div 
                         v-for="optEnterprise in sortedEnterprises" 
                         :key="optEnterprise.id" 
                         class="enterprise-card"
                         :class="{ 'active': optEnterprise.id === enterpriseId }"
                         @click="enterpriseId = optEnterprise.id"
                      >
                         <div class="card-icon">
                            <i class="siscont icon_location"></i>
                         </div>
                         <div class="card-details">
                            <span class="company-name">
                              {{ optEnterprise.name }}
                              <span class="badge-current" v-if="optEnterprise.id === currentAppEnterpriseId">Atual</span>
                            </span>
                         </div>
                         <div class="card-radio">
                            <div class="radio-inner" v-if="optEnterprise.id === enterpriseId"></div>
                         </div>
                      </div>
                    </div>

                </div>
                <div class="modal-footer border-0 pb-4 px-4 pt-2 d-flex justify-content-end gap-2">
                    <button v-if="hasEnterprise" type="button" class="btn btn-light rounded-pill px-4 fw-semibold" data-bs-dismiss="modal" @click="cancelSelection" style="color: #64748b; background: #f1f5f9; border: none; font-size: 14px;">Cancelar</button>
                    <button type="button" class="btn rounded-pill px-4 fw-semibold" data-bs-dismiss="modal" @click="setCurrentEntreprise" :disabled="!enterpriseId" style="background: var(--default-blue, #0ea5e9); color: white; border: none; font-size: 14px; box-shadow: 0 4px 12px rgba(14, 165, 233, 0.3);">{{txtBtnModal}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { Modal } from 'bootstrap';

  export default {
    name: 'ModalEnterprise',
    props: {
      modalTitle: String,
      txtBtnModal: String,
    },
    data () {
      return {
        enterpriseId: this.$store.getters.getEnterpriseId
      }
    },
    computed: {
      currentAppEnterpriseId() {
        return this.$store.getters.getEnterpriseId;
      },
      hasEnterprise() {
        return !!this.$store.getters.getEnterpriseId;
      },
      sortedEnterprises() {
        const enterprises = this.$store.getters.getEnterprises || [];
        const currentId = this.currentAppEnterpriseId;
        
        // Separa a empresa ativa para jogar ela sempre para o topo
        const currentList = enterprises.filter(e => e.id === currentId);
        const othersList = enterprises.filter(e => e.id !== currentId);
        
        return [...currentList, ...othersList];
      }
    },
    methods: {
      removeFocus() {
        if (document.activeElement) {
          document.activeElement.blur();
        }
      },
      cancelSelection() {
        this.removeFocus();
        this.enterpriseId = this.$store.getters.getEnterpriseId;
      },
      setCurrentEntreprise() {
        this.removeFocus();
        if (this.$store.getters.getEnterpriseId != this.enterpriseId) {
          this.$store.commit('setEnterpriseId', this.enterpriseId);
          this.$router.go(this.$router.currentRoute);
        }
      },
      openModalViaBs() {
        // Usa a API do Bootstrap diretamente para garantir que o modal abre
        // independente do timing de inicialização — getOrCreateInstance é seguro
        // de chamar a qualquer momento, mesmo logo após o elemento ser montado
        const modalEl = document.getElementById('modalEnterprise');
        if (!modalEl) return;
        const bsModal = Modal.getOrCreateInstance(modalEl);
        bsModal.show();
      },
      checkAndOpenModal() {
        const enterpriseId = this.$store.getters.getEnterpriseId;
        const loggedIn = this.$store.getters.getLoggedIn;
        const routeName = this.$route.name;
        // Não abre o modal durante a tela de login ou nas rotas isentas
        if (!enterpriseId && loggedIn && routeName !== 'orderCreate' && routeName !== 'login') {
          this.$nextTick(() => {
            // Pequeno delay para garantir que o Bootstrap concluiu a inicialização
            // do elemento recém-montado no DOM antes de tentar exibir o modal
            setTimeout(() => {
              this.openModalViaBs();
            }, 200);
          });
        }
      },
      eventListenerCloseModalEnterprise() {
        this.removeFocus();
        const enterpriseId = this.$store.getters.getEnterpriseId;
        if (!enterpriseId) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.openModalViaBs();
            }, 50);
          });
          return false;
        }
        return true;
      }
    },
    watch: {
      '$store.state.enterpriseId': {
        immediate: true,
        handler(newEnterpriseId) {
          if (newEnterpriseId && (newEnterpriseId != this.enterpriseId)) {
            this.enterpriseId = newEnterpriseId;
          }
        }
      },
      // Detecta o momento exato do login para abrir o modal se necessário
      '$store.getters.getLoggedIn': {
        handler(loggedIn) {
          if (loggedIn) {
            this.checkAndOpenModal();
          }
        }
      },
      // Detecta quando as empresas são carregadas após o login (getInfoUserLogged é async)
      // — esse é o watch mais importante pois garante que a lista já existe quando o modal abre
      '$store.state.enterprises': {
        handler(enterprises) {
          if (enterprises && enterprises.length > 0) {
            this.checkAndOpenModal();
          }
        }
      },
      // Detecta a navegação pós-login: o modal não pode abrir na rota 'login',
      // então observamos a mudança de rota para abrir quando chegar na home
      '$route'(to, from) {
        if (from.name === 'login' && to.name !== 'login') {
          this.checkAndOpenModal();
        }
      },
    },
    mounted() {
      const myModal = document.getElementById('modalEnterprise');
      if (myModal) {
        myModal.addEventListener('hidden.bs.modal', () => this.eventListenerCloseModalEnterprise());
        myModal.addEventListener('show.bs.modal', () => {
          this.enterpriseId = this.$store.getters.getEnterpriseId;
        });
      }
      // Verifica ao montar — cobre o caso de F5/reload com sessão ativa sem empresa
      this.checkAndOpenModal();
    },
  };
</script>

<style scoped lang="scss">
.enterprise-cards-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: 50vh;
    overflow-y: auto;
    padding: 4px;
    
    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #cbd5e1;
        border-radius: 10px;
    }
}

.enterprise-card {
    display: flex;
    align-items: center;
    padding: 16px;
    background: #ffffff;
    border: 2px solid #f1f5f9;
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        border-color: #bae6fd;
        background: #f8fafc;
        transform: translateY(-2px);
        box-shadow: 0 8px 24px -4px rgba(14, 165, 233, 0.1);
    }

    &.active {
        border-color: var(--default-blue, #0ea5e9);
        background: #f0f9ff;
        
        .card-icon {
            background: var(--default-blue, #0ea5e9);
        }
        
        .card-icon i,
        .card-icon i::before {
            color: #ffffff !important;
        }

        .company-name {
            color: var(--default-blue, #0ea5e9);
            font-weight: 700;
        }
    }
}

.card-icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: #f1f5f9;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    margin-right: 16px;
    transition: background 0.2s ease;
    
    i, i::before {
        transition: color 0.2s ease;
    }
}

.card-details {
    flex: 1;
    display: flex;
    flex-direction: column;

    .company-name {
        display: flex;
        align-items: center;
        font-size: 15px;
        font-weight: 600;
        color: #334155;
    }
    
    .badge-current {
        margin-left: 10px;
        background: #e2e8f0;
        color: #475569;
        font-size: 10px;
        font-weight: 800;
        padding: 2px 6px;
        border-radius: 4px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }
}

.enterprise-card.active .card-details .badge-current {
    background: #bae6fd;
    color: #0369a1;
}

.card-radio {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 2px solid #cbd5e1;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.enterprise-card.active .card-radio {
    border-color: var(--default-blue, #0ea5e9);
    
    .radio-inner {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: var(--default-blue, #0ea5e9);
    }
}
</style>